import { ErrorHandler, Injectable } from '@angular/core';

// overriding the instance method 'call' of exception handler  'ExceptionHandler'
// https://github.com/angular/angular/blob/bb8976608db93b9ff90a71187608a4390cbd7a07/modules/%40angular/facade/src/exception_handler.ts
// https://github.com/angular/angular/issues/6865

@Injectable()
export class MyExceptionHandler extends ErrorHandler {

    constructor() {
        super(); // do not pass argument to ErrorHandler as it no longer rethrows
    }                                    // overriding _ArrayLogger to console the errors

    handleError(error) {
        try {
            super.handleError(error); // overriding the call method
        } catch (ex) {
            console.error(ex);
        }

    }
}

class _ArrayLogger {
    res = [];
    log(s: any): void {
        this.res.push(s);
    }
    logError(s: any): void {
        this.res.push(s);
    }
    logGroup(s: any): void {
        this.res.push(s);
    }
    logGroupEnd() {
        this.res.forEach(error => { // This logs the errors to the console
            console.error(error);
        });
    }
}
